import React from "react";

/**
 * The qualification that opens a template name, shown beside the field where
 * only the rest is typed. Same height as a StyledInput so both texts line up.
 */
const TemplateNamePrefix = ({ prefix }) => {
    if (!prefix) return null;

    return (
        <span
            className={
                "shrink-0 max-w-[55%] h-10 px-3 flex items-center rounded-l-[0.4rem] border border-r-0 border-gray-200 bg-gray-100 text-sm text-gray-800"
            }
            title={prefix}
        >
            <span className={"truncate"}>{prefix}</span>
        </span>
    );
};

export default TemplateNamePrefix;
